import { Features } from "./components/features"
import { Hero } from "./components/hero"


export const Home =()=>{
    return <>
        <Hero/>
        <Features/>
    </>
}